import { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import CoachesSidebar from "./CoachesSidebar";
import CoachesContent from "./CoachesContent";
import SEOHelmet from "../../../Components/SeoHelmet";

export default function Coaches() {
  // استیت‌های مربوط به فیلترها (بر اساس ساختار داینامیک جدید)
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedExperience, setSelectedExperience] = useState("");
  const [isDiscount, setIsDiscount] = useState(undefined);

  const queryParams = {
    search: searchQuery || undefined,
    mainSpecialty: selectedSport?._id || undefined,
    province: selectedProvince?._id || undefined,
    city: selectedCity?._id || undefined,
    area: selectedArea?._id || undefined,
    isDiscount,
    gender:
      selectedGender && selectedGender !== "all" ? selectedGender : undefined,
    experience:
      selectedExperience && selectedExperience !== "all"
        ? selectedExperience
        : undefined,
  };

  return (
    <>
      <SEOHelmet
        title="جستجو و رزرو بهترین مربیان ورزشی | آدین زون"
        description="پروفایل برترین مربیان شخصی بدنسازی، فیتنس و سایر رشته‌ها را مشاهده کنید. سوابق، مدارک، تعرفه جلسات و برنامه تمرینی مربیان حرفه‌ای در آدین زون."
        keywords="مربی بدنسازی, مربی آنلاین, مربی شخصی, رزرو مربی ورزشی, برنامه تمرینی, مربی فیتنس بانوان, مربی خصوصی"
        author="AdinZone"
      />
      <Box
        component="main"
        sx={{
          minHeight: "100vh",
          bgcolor: "background.default",
          py: { xs: 4, sm: 6, md: 8 },
          px: { xs: 1.5, sm: 2, md: 3, lg: 4, xl: 6 },
        }}
      >
        <Container
          maxWidth="xxl"
          sx={{
            px: { xs: 1, sm: 2, md: 3, lg: 4 },
          }}
        >
          {/* Header */}
          <Box component="header" sx={{ my: { xs: 3, sm: 4, md: 5, lg: 2 } }}>
            <Typography
              component="h1"
              variant="h4"
              fontWeight={800}
              sx={{
                background: "linear-gradient(135deg, #5c6bc0 0%, #8c9eff 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
                mb: 1,
                fontSize: {
                  xs: "1.5rem",
                  sm: "1.75rem",
                  md: "2rem",
                  lg: "2.25rem",
                },
              }}
            >
              مربیان حرفه‌ای
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
            >
              بهترین مربیان ورزشی ایران را پیدا کنید و از تجربه آن‌ها بهره‌مند
              شوید
            </Typography>
          </Box>

          {/* Main layout */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "220px 1fr",
                lg: "260px 1fr",
                xl: "300px 1fr",
              },
              gap: { xs: 2, sm: 2.5, md: 3 },
            }}
          >
            {/* ارسال استیت‌ها و توابع تغییردهنده به سایدبار */}
            <CoachesSidebar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              selectedSport={selectedSport}
              setSelectedSport={setSelectedSport}
              selectedProvince={selectedProvince}
              setSelectedProvince={setSelectedProvince}
              selectedCity={selectedCity}
              setSelectedCity={setSelectedCity}
              selectedArea={selectedArea}
              setSelectedArea={setSelectedArea}
              selectedGender={selectedGender}
              setSelectedGender={setSelectedGender}
              selectedExperience={selectedExperience}
              setSelectedExperience={setSelectedExperience}
              isDiscount={isDiscount}
              setIsDiscount={setIsDiscount}
            />

            {/* ارسال پارامترهای فیلترشده به محتوا */}
            <CoachesContent queryParams={queryParams} />
          </Box>
        </Container>
      </Box>
    </>
  );
}
